import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ChatBot from './components/ChatBot/ChatBot';
import Home from './pages/Home/Home';
import Branches from './pages/Branches/Branches';
import CuttingProcess from './pages/CuttingProcess/CuttingProcess';
import EscomaticProcess from './pages/EscomaticProcess/EscomaticProcess';
import QualityAssurance from './pages/QualityAssurance/QualityAssurance';
import Products from './pages/Products/Products';
import Awards from './pages/Awards/Awards';
import Contact from './pages/Contact/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/cutting-process" element={<CuttingProcess />} />
          <Route path="/escomatic-process" element={<EscomaticProcess />} />
          <Route path="/quality-assurance" element={<QualityAssurance />} />
          <Route path="/products" element={<Products />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
}

export default App;
